import React, { useEffect, useState } from "react";
import image from "../../../assets/images/NoTeam.png";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Menu,
  MenuItem,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import classes from "./myteam.module.css";
import { useNavigate } from "react-router-dom";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { TEAM_LIST } from "../../../api-calls/api-urls";
import { useDispatch, useSelector } from "react-redux";
import { generateColor, stringAvatar } from "../../../utilities/commonFunctions";
import {
  currentEditTeam,
  teamsList,
} from "../../../Redux/actions/team-actions";
import { BsThreeDotsVertical } from "react-icons/bs";
import { getLanguagedataFunction } from "../../../utilities/language";
import {
  DeleteBinIcons,
  EditPenIcon,
  RoundAddIcon,
} from "../../../components/Icons";

const IndexTab = (props) => {
  const navigate = useNavigate();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [dataList, setDataList] = useState();
  const dispatch = useDispatch();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [checked, setChecked] = useState();
  const [selected, setSelected] = useState();
  const teamList = useSelector((state) => state.teams.teamsList);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [deleteModal, setDeleteModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const ln = useSelector((state) => state.allUsers.language_json);
  const [btnName, setBtnName] = useState(ln ? ln.add_team : null);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once on mount (getLanguagedataFunction is idempotent)

  const handleMenuclick = (event, item) => {
    event.stopPropagation();
    setSelected(item);
    setAnchorEl(event.currentTarget);
  };

  const handleCardClick = (event, item) => {
    const name = item.slug.toLowerCase();
    navigate(`/my-team/${name}`);
    event.preventDefault();
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const handleMenuItemClick = async (event, name) => {
    event.stopPropagation();
    if (name === "edit") {
      dispatch(currentEditTeam(selected));
      navigate(`/my-team/update/${selected.slug.toLowerCase()}`);
      handleClose(event);
    } else if (name === "delete") {
      setDeleteModal(true);
      handleClose(event);
      // const { data } = await authApi.delete(`${TEAM_LIST}/${selected._id}`, {
      //   headers: { Authorization: getAuthorizationHeader() },
      // });
      // console.log(data);
      // getData();
    }
  };
  const handleClick = () => {
    dispatch(currentEditTeam());
    navigate("/my-team/create-team");
  };
  useEffect(() => {
    if (props && (props.name !== "team") & ln) {
      setBtnName(ln.create_department);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (props && props.name === "team") {
      getData();
    } else {
      dispatch(teamsList(null));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!teamList]);

  // eslint-disable-next-line unused-imports/no-unused-vars
  const closeModal = () => {
    setDeleteModal(false);
    getData();
  };

  const getData = async () => {
   try {
    const { data } = await authApi.get(TEAM_LIST, {
      headers: { Authorization: getAuthorizationHeader() },
    });
    dispatch(teamsList(data));
   } catch (error) {
     // Intentionally ignored — not surfaced to the user
   }
  };
  return (
    <div>
      {ln ? (
        <div>
          {teamList && teamList?.length > 0 ? (
            <div className={classes.indexpageMainBtn}>
              <Button variant="contained" onClick={() => handleClick()}>
                <RoundAddIcon />
                <span style={{ marginLeft: "7px" }}>{btnName}</span>
              </Button>
            </div>
          ) : null}
          <Paper
            elevation={0}
            sx={{ 
              p: 3, 
              backgroundColor: 'transparent',
              minHeight: '60vh'
            }}
          >
            {teamList && teamList?.length > 0 ? (
              <Box>
                <Grid container spacing={3}>
                  {teamList.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={item._id || index}>
                      <Card
                        sx={{
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: (theme) => theme.shadows[4]
                          }
                        }}
                        onClick={(e) => handleCardClick(e, item)}
                      >
                        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, position: 'relative' }}>
                          <Avatar
                            {...stringAvatar(item.team_name)}
                            sx={{
                              backgroundColor: generateColor(item.team_name),
                              width: 48,
                              height: 48
                            }}
                          />
                          <Box sx={{ flexGrow: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                              {item.team_name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {ln.total_members}: {item.team_members && item.team_members[0].user_name ? item.team_members?.length : 0}
                            </Typography>
                          </Box>
                          <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
                            <Button
                              size="small"
                              sx={{ minWidth: 32, p: 0.5 }}
                              onClick={(e) => handleMenuclick(e, item)}
                            >
                              <BsThreeDotsVertical />
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                  <MenuItem onClick={(e) => handleMenuItemClick(e, "edit")}>
                    <EditPenIcon sx={{ mr: 1, fontSize: 18 }} />
                    <Typography variant="body2">{ln.edit_team}</Typography>
                  </MenuItem>
                  <MenuItem onClick={(e) => handleMenuItemClick(e, "delete")}>
                    <DeleteBinIcons sx={{ mr: 1, fontSize: 18, color: 'error.main' }} />
                    <Typography variant="body2" color="error">{ln.delete_team}</Typography>
                  </MenuItem>
                </Menu>
              </Box>
            ) : (
              <Stack
                spacing={3}
                alignItems="center"
                justifyContent="center"
                sx={{ py: 8, textAlign: 'center' }}
              >
                <img
                  src={image}
                  alt="createTeam"
                  style={{ width: '100%', maxWidth: '350px', height: 'auto' }}
                />
                <Typography variant="h5" sx={{ maxWidth: '500px', fontWeight: 600 }}>
                  You don't have any teams currently. Please create a team to view here.
                </Typography>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => handleClick()}
                  startIcon={<RoundAddIcon />}
                >
                  {btnName}
                </Button>
              </Stack>
            )}
          </Paper>
        </div>
      ) : null}
    </div>
  );
};

export default IndexTab;
